import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IframeService {
  constructor() {
    this.initializeIframes();
  }

  private initializeIframes(): void {
    if(typeof window !== "undefined"){
      const iframes = document.getElementsByTagName('iframe');

      window.addEventListener('message', (e) => {
        this.adjustIframeSize(e.data);
      });

      if (iframes.length) {
        for (let i = 0; i < iframes.length; i++) {
          if (-1 !== iframes[i].className.indexOf('gfiframe')) {
            this.watchIframe(i, iframes);
          }
        }
      }
    }
  }

  private adjustIframeSize(data: any): void {
    if ('size' === data.message) {
      const iframes = document.getElementsByTagName('iframe');
      const iframe = iframes[0];

      if (typeof iframe !== 'undefined') {
        iframe.height = data.height;
      }
    }
  }

  private watchIframe(index: number, iframes: HTMLCollectionOf<HTMLIFrameElement>): void {
    iframes[index].onload = () => {
      setInterval(() => {
        this.sendSizeMessageToIframe(index, iframes);
      }, 500);
    };
  }

  private sendSizeMessageToIframe(index: number, iframes: HTMLCollectionOf<HTMLIFrameElement>): void {
    if(iframes[index]?.contentWindow){
      // @ts-ignore
      iframes[index].contentWindow.postMessage({
        message: 'size',
        index
      }, '*');
    }

  }
}
